export default "__VITE_ASSET__6e186616__"